import Page from 'client/components/aria/Page/Page';
import LoadingScreen from 'client/components/suc/LoadingScreen/LoadingScreen';

const LoadingPage = () => {
    return (
        <Page
            title="Loading..."
            data-testid="loadingPage"
        >
            <LoadingScreen/>
        </Page>
    );
};

export default LoadingPage;
